import { Button, Card, TextField, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import React from "react";
import {
  Control,
  Controller,
  UseFieldArrayRemove,
  useWatch,
} from "react-hook-form";
import { useTranslation } from "react-i18next";

import { formatPrice } from "../../../shared/functions/formatPrice";
import {
  IInvoice,
  IInvoiceItem,
} from "../../../shared/interfaces/invoice/IInvoice";

interface IProps {
  index: number;
  item: IInvoiceItem;
  remove: UseFieldArrayRemove;
  control: Control<IInvoice>;
}
const InvoiceItem = ({ index, item, control, remove }: IProps) => {
  const { t } = useTranslation();
  const watchedFields = useWatch({
    name: `items.${index}`,
    control,
  });

  return (
    <Card sx={{ mb: "20px" }}>
      <Grid
        container
        spacing={2}
        sx={{ display: "flex", alignItems: "center" }}
        key={item.id}
      >
        <Grid
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <Controller
            name={`items.${index}.name`}
            control={control}
            render={({ field, fieldState }) => (
              <TextField
                {...field}
                label={t("invoice.itemName")}
                error={!!fieldState.error}
                helperText={t(fieldState.error?.message || "")}
                fullWidth
              />
            )}
          />
        </Grid>

        <Grid
          size={{
            xs: 12,
            md: 3,
          }}
        >
          <Controller
            name={`items.${index}.quantity`}
            control={control}
            render={({ field, fieldState }) => (
              <TextField
                {...field}
                label={t("invoice.quantity")}
                type="number"
                error={!!fieldState.error}
                helperText={t(fieldState.error?.message || "")}
                fullWidth
              />
            )}
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 3,
          }}
        >
          <Controller
            name={`items.${index}.price`}
            control={control}
            render={({ field, fieldState }) => (
              <TextField
                {...field}
                label={t("general.price")}
                type="number"
                error={!!fieldState.error}
                helperText={t(fieldState.error?.message || "")}
                fullWidth
              />
            )}
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
          }}
        >
          <Controller
            name={`items.${index}.description`}
            control={control}
            render={({ field, fieldState }) => (
              <TextField
                {...field}
                label={t("general.description")}
                error={!!fieldState.error}
                helperText={t(fieldState.error?.message || "")}
                fullWidth
                multiline
                rows={3}
              />
            )}
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <Typography variant={"subtitle1"}>
            {t("invoice.total")}:{" "}
            {formatPrice(watchedFields?.price * watchedFields?.quantity)}
          </Typography>
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 6,
          }}
          sx={{
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Button
            onClick={() => remove(index)}
            color="error"
            variant={"contained"}
          >
            - {t("button.removeItem")}
          </Button>
        </Grid>
      </Grid>
    </Card>
  );
};

export default InvoiceItem;
